<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Payable Aging"
            />
            <div class="row match-height">
                <div class="col-12 col-lg-12 col-xl-12 col-xxl-12 mt-2">
                    <DateQuerySetter
                        @onClickGo="getPayables"
                        :isVisibleFromDate="false"
                    >
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <label for="colFormLabel" class="col-form-label">Days Per Aging Period</label>
                        <input type="text" v-model="daysPerAgingPeriod"  class="form-control" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <label for="colFormLabel" class="col-form-label">Number Of Periods</label>
                        <input type="text" v-model="numberOfPeriod"  class="form-control" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <label for="colFormLabel" class="col-form-label">Roles</label>
                        <v-select
                            placeholder="Select Roles"
                            v-model="companyRoleId"
                            :options="companyRoles"
                            label="name"
                            :reduce="name => name.id"
                        />
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                        <label for="colFormLabel" class="col-form-label">Party</label>
                        <AsyncSelect
                            placeholder="Party Name, ID, Mobile No"
                            v-model="contactProfile"
                            :api-service="fetchContactProfiles"
                            :format-label="formatPatientLabel"
                        />
                      </div>
                    </DateQuerySetter>
                </div>
              <div class="d-flex justify-content-end px-2 mt-2 mb-2 mr-2">
                <button class="btn btn-primary btn-block waves-effect waves-float waves-light print-btn me-2" @click="goToPrint">
                  Print
                </button>
                <button class="btn btn-primary btn-block waves-effect waves-float waves-light" @click="exportReport">
                  Export
                </button>
              </div>
            </div>
        </div>

        <div class="mt-2 px-2">
          <div class="table-responsive table-striped my-1" style="min-height: 200px">
            <table class="table">
              <thead class="table-light">
              <tr>
                <th>SL No</th>
                <th>Customer ID</th>
                <th>Customer Name</th>
                <th>Mobile</th>
                <th class="text-right">Current</th>
                <th
                    v-for="(period, index) in agingPeriods"
                    :key="index"
                    class="text-right"
                >
                  {{ period.label || '' }}
                </th>
                <th class="text-right">Closing Balance</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item ,index) in payable" :key="index">
                <td>{{ from + index }}</td>
                <td>{{item.serial_no}}</td>
                <td>{{item.name}}</td>
                <td>{{item.phone}}</td>
                <td class="text-right">{{ commaFormat(item.current_balance) }}</td>
                <td
                    v-for="(period, periodIndex) in agingPeriods"
                    :key="periodIndex"
                    class="text-right"
                >
                  {{ commaFormat(item[period.label] || 0) }}
                </td>
                <td class="text-right">{{ commaFormat(item.closing_balance) }}</td>
              </tr>
              </tbody>
            </table>
            <p v-if="!payable.length" class="mt-5 text-center">No data</p>
          </div>
        </div>
      <div class="px-2">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
      <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import Loader from "@/components/atom/LoaderComponent.vue";
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import useReport from '@/services/modules/dashboard/report.js'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleRole from "@/services/modules/role";
import handleContact from "@/services/modules/contact";
import figureFormatter from '@/services/utils/figureFormatter'

import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleCompany from "@/services/modules/company";
import payableAgingPdf from "@/services/utils/pdf/payableAgingPdf";
import {useStore} from "vuex";
import Pagination from "@/components/atom/Pagination.vue";
const { fetchPayableAging } = useReport()
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = payableAgingPdf();

const route = useRoute()
const router = useRouter();
const store = useStore();

let offset = ref(200)
const loading = ref(false);

const payable = ref([])
const agingPeriods = ref([])
const companyRoles = ref([])
const companyRoleId = ref(null)
const daysPerAgingPeriod = ref(30)
const numberOfPeriod = ref(3)
const contactProfile = ref(null);
const companyInfo = ref(null);
const isFetchAll = ref(false);
const payablePdfData = ref([]);
const from = computed(()=> store.state.paginationData.from)
const {commaFormat} = figureFormatter ()

onMounted(() => {
  getDefaultRoles();
  getCompany();
})

function getQuery () {
    let queryStr = '?company_id=' + route.params.companyId
    queryStr += '&offset=' + offset.value
    if (route.query.page) queryStr += "&page=" + route.query.page;
    if(companyRoleId.value) queryStr += '&company_role_id=' + companyRoleId.value;
    if(contactProfile.value) queryStr += '&contact_profile_id=' + contactProfile.value.id;
    if(daysPerAgingPeriod.value) queryStr += '&days_per_aging_period=' + daysPerAgingPeriod.value;
    if(numberOfPeriod.value) queryStr += '&number_of_period=' + numberOfPeriod.value;
    if(isFetchAll.value) queryStr += '&is_fetch_all=' + isFetchAll.value;
    if(!route.query.end) return queryStr
    return queryStr+`&payable_date={
    "start": "${route.query.start}",
    "end": "${route.query.end}"
    }`
}

const getPayables = async () => {
  loading.value = true;
  try {
    const res = await fetchPayableAging(getQuery());

    if (!res.status) {
      payable.value = []
      agingPeriods.value = [];
      return store.commit("resetPagination")
    }

    if(isFetchAll.value){
      payablePdfData.value = res.data;
      agingPeriods.value = res.aging_periods;
      return;
    }

    payable.value = res.data.data;
    agingPeriods.value = res.aging_periods;

    if (payable.value.length > 0) {
      setPagination(res.data)
    }

  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  } finally {
    loading.value = false;
  }
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};
const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPayables()
}
const setPagination = (data) => {
  setPaginationData({
    from: data.from,
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const getDefaultRoles = async () => {
  const companyQuery = `?company_id=${route.params.companyId}`
  const res = await fetchCompanyDefaultRoles(companyQuery)
  if(res.status) {
    companyRoles.value = res.data;
  }
}

const getCompany = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  })
}

const goToPrint = async() => {

  const payload = {
    startDate: route.query.start,
    endDate: route.query.end,
    role: '',
    party: contactProfile.value ? contactProfile.value.name : '',
  };

  if(companyRoleId.value){
    const role = companyRoles.value.find(item => item.id === companyRoleId.value)
    payload.role = role.name;
  }

  isFetchAll.value = true;

  await getPayables().then(() => {
    if(!payablePdfData.value.length) return;
    exportToPDF(companyInfo.value, payablePdfData.value, agingPeriods.value, payload)
  })

  isFetchAll.value = false;
}

const exportReport = () => {
  let token = localStorage.getItem('token');
  let url = `${process.env.VUE_APP_BASE_URL}/export/accounting/payable-aging${getQuery()}&_token=${token}&is_export=1`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}
</script>
